import { Component } from '@angular/core';
import { BaryTableDataEnum } from 'models/bary-table/bary-table-data';
import { QuotationService } from '../../../../services/quotation.service';

@Component({
  selector: 'jhi-my-quotations-ongoing',
  templateUrl: './my-quotations-ongoing.component.html',
  styleUrls: ['../my-quotations-tab.component.scss'],
})
export class MyQuotationsOngoingComponent {
  TABLE_TYPE = BaryTableDataEnum;

  constructor(public quotationsService: QuotationService) {}
}
